import React, { Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import './ListingCard.css';

const ListingCard = ({ listing, onClick, isClosed = false, isSuperAdmin = false }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) onClick();
    navigate(`/listing/${listing.id}`);
  };
  const formatDate = (dateStr) => {
    if (!dateStr) return null;
    try {
      if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) return dateStr;
      return new Date(dateStr).toLocaleDateString('en-US', {
        year: 'numeric', month: 'short', day: 'numeric',
      });
    } catch {
      return dateStr;
    }
  };

  const formatUploadDate = (dateStr) => {
    if (!dateStr) return 'N/A';
    try {
      if (typeof dateStr === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
        const [year, month, day] = dateStr.split('-').map(Number);
        return new Date(year, month - 1, day).toLocaleDateString('en-US', {
          year: 'numeric', month: 'short', day: 'numeric',
        });
      }
      const date = new Date(dateStr);
      if (Number.isNaN(date.getTime())) return dateStr;
      return date.toLocaleDateString('en-US', {
        year: 'numeric', month: 'short', day: 'numeric',
      });
    } catch {
      return dateStr;
    }
  };

  const formatPrice = (val) => {
    if (!val) return null;
    return Number(val).toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
  };

  const isSellersideRole = (role) => {
    const r = (role || '').toLowerCase().replace(/[^a-z]/g, '');
    return (r.includes('seller') || r.includes('coseller')) && !r.includes('agent') && !r.includes('coordinator') && r !== 'tc';
  };
  const sellerNames = (listing.parties || []).filter(p => isSellersideRole(p.role)).map(p => p.name).filter(Boolean);
  const sellerDisplay = sellerNames.length > 0
    ? sellerNames.map((name, i) => (
        <Fragment key={i}>{name}{i < sellerNames.length - 1 && <>{' &'}<br /></>}</Fragment>
      ))
    : 'N/A';

  const listingAgent = (listing.parties || []).find(p => {
    const r = (p.role || '').toLowerCase();
    return r.includes('listing agent') || r.includes('listing_agent') || r === "seller's agent" || r === 'sellers_agent' || r === 'sellers agent';
  });
  const keyfloAgent = isSuperAdmin && listingAgent?.name ? listingAgent.name : null;

  const uploadedDate = listing.created_at || null;

  const statusLabel = isClosed ? (listing.status || 'closed').toUpperCase() : null;
  const hasIssues = !isClosed && Number(listing.open_compliance_issues_count) > 0;

  return (
    <div className={`listing-card ${isClosed ? 'listing-card-closed' : ''}`} onClick={handleClick}>
      {hasIssues && (
        <div className="badge-group">
          <div className="badge-issue">
            {listing.open_compliance_issues_count} Issue{listing.open_compliance_issues_count !== 1 ? 's' : ''}
          </div>
        </div>
      )}
      <div className="listing-card-header">
        <h3 className="property-address" style={{ margin: 0 }}>
          {listing.street_address}
        </h3>
        <span className="listing-type-label">{statusLabel || 'Listing'}</span>
      </div>
      <div className="card-body">

        <div className="info-row">
          <span className="info-label">Seller</span>
          <span className="info-value">{sellerDisplay}</span>
        </div>

        <div className="info-row">
          <span className="info-label">List Price</span>
          <span className="info-value">{formatPrice(listing.listing_price) || 'N/A'}</span>
        </div>

        <div className="closing-date-section">
          <div className="info-row" style={{ marginBottom: 0 }}>
            <span className="info-label">Expires</span>
            <span className="info-value">{formatDate(listing.expiration_date) || 'N/A'}</span>
          </div>
        </div>
      </div>
      <div className="card-footer">
        {keyfloAgent && (
          <div className="meta-row" style={{ marginBottom: '4px' }}>
            <span style={{ fontSize: '0.72rem', color: '#7fb069', fontWeight: 600 }}>
              {keyfloAgent}
            </span>
          </div>
        )}
        <div className="meta-row">
          {isClosed && <span className="closed-label">CLOSED</span>}
          <span>Uploaded: {formatUploadDate(uploadedDate)}</span>
        </div>
      </div>
    </div>
  );
};

export default ListingCard;
